import React, { useState } from "react";
import { SignInApi } from "../../ApiRequests";
import { ErrorToast } from "../../utils/ShowToast";
import AuthInput from "../Input/AuthInput";
import AuthInputPassword from "../Input/AuthInputPassword";
import { FaSpinner } from "react-icons/fa";
import { FiAlertCircle, FiCheckCircle } from "react-icons/fi";

const LoginPage = () => {
  const [errorOccur, setErrorOccur] = useState(false);
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  const [Loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!Email || !Password) {
      ErrorToast("Email and password are required");
      return;
    }
    setLoading(true);
    setErrorOccur(false);
    try {
      const { data } = await SignInApi({
        email: Email,
        password: Password,
      });
      localStorage.setItem("user", JSON.stringify(data.data.payload.user));
      localStorage.setItem("token", data.data.payload.token);
      localStorage.setItem("role", data.data.payload.user.role);
      if (data.data.payload.user.role === 2)
        localStorage.setItem("branch", data.data.payload.user.branch_number);
      window.location.reload();
    } catch (err) {
      console.log(err);
      setErrorOccur(true);
      ErrorToast(err.response?.data?.error?.msg || "Check email and password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-[420px]">
      <div className="rounded-2xl border border-line bg-card px-7 py-8 sm:px-9 sm:py-9 shadow-card">
        <span className="inline-block rounded-md bg-brandSoft px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-main">
          Sign in
        </span>

        <h1 className="mt-4 text-[1.65rem] font-bold text-ink tracking-tight">
          Welcome back
        </h1>
        <p className="mt-1.5 text-sm text-muted">
          Enter your credentials to access your dashboard
        </p>

        <form onSubmit={onSubmit} className="mt-7 flex flex-col" noValidate>
          {errorOccur && (
            <div
              role="alert"
              className="mb-4 flex items-start gap-2 rounded-lg bg-dangerSoft border border-danger/20 px-3 py-2.5 text-sm font-medium text-danger"
            >
              <FiAlertCircle className="shrink-0 mt-0.5" size={16} aria-hidden />
              <span>Invalid email or password. Please try again.</span>
            </div>
          )}

          <AuthInput
            label="Email address"
            placeholder="you@company.com"
            Value={Email}
            setValue={setEmail}
            required
            Type="text"
            uppercaseAllowed
            Width="w-full"
            autoComplete="username"
            autoFocus
            labelLayout="stacked"
            variant="auth"
            icon="mail"
          />
          <AuthInputPassword
            label="Password"
            placeholder="Enter your password"
            Value={Password}
            setValue={setPassword}
            required
            autoComplete="current-password"
            labelLayout="stacked"
            variant="auth"
            Width="w-full"
          />

          <div className="mb-5 -mt-1 flex items-center justify-between">
            <label className="flex cursor-pointer items-center gap-2 text-sm text-inkSecondary">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="h-4 w-4 rounded border-line text-main focus:ring-main"
              />
              Remember me
            </label>
            <button
              type="button"
              className="text-sm font-semibold text-main hover:text-mainHover"
            >
              Forgot password?
            </button>
          </div>

          <button
            type="submit"
            disabled={Loading}
            className="w-full h-11 rounded-lg bg-main hover:bg-mainHover text-white font-bold text-sm transition-colors disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-main/30 focus-visible:ring-offset-2"
          >
            {Loading ? (
              <>
                <FaSpinner className="animate-spin" aria-hidden />
                Signing in…
              </>
            ) : (
              "Sign in to dashboard"
            )}
          </button>
        </form>

        <p className="mt-6 text-center text-xs text-muted">
          © 2026 Irshad Carton Dealer. All rights reserved.
        </p>
      </div>

      <p className="mt-5 flex items-center justify-center gap-1.5 text-xs text-muted">
        <FiCheckCircle className="text-success shrink-0" size={14} aria-hidden />
        256-bit encrypted · Secure authentication
      </p>
    </div>
  );
};

export default LoginPage;
